// Invoice Document component for preview using @react-pdf/renderer
// Accepts a single canonical InvoiceDisplayModel and renders it inside PDFViewer.
import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import InvoiceDocumentPdf from "./InvoiceDocumentPdf";

const InvoiceDocument = ({ model, showToolbar = true }) => {
  return (
    <div style={{ width: "100%", minHeight: "1123px" }}>
      <PDFViewer
        style={{ width: "100%", height: "1123px" }}
        showToolbar={showToolbar}
      >
        <InvoiceDocumentPdf model={model} />
      </PDFViewer>
    </div>
  );
};

export default InvoiceDocument;
